<template>
  <section>
    Страница <strong>{{ title }}</strong> в разработке
  </section>
</template>

<script>
export default {
  name: 'PageUnderConstruction',
  data() {
    return {
      title: '',
    };
  },
  watch: {
    '$route.params.title': {
      immediate: true,
      handler() {
        this.title = this.$route.params.title;
      },
    },
  },
};
</script>
